/**
 * Shared helpers for the overlay library.
 * Everything renders inside the 60×130 tooth viewBox.
 * Crown occupies y ∈ [20, 90], root y ∈ [90, 128], center x = 30.
 */

// Anatomical anchor points for each surface. Values chosen so overlays sit
// convincingly on the tooth crown regardless of type.
export const SURFACE_POS = {
  O: { cx: 30, cy: 56 },   // Occlusal — central pit
  M: { cx: 15, cy: 55 },   // Mesial (toward midline)
  D: { cx: 45, cy: 55 },   // Distal (away from midline)
  B: { cx: 30, cy: 32 },   // Buccal / Facial
  L: { cx: 30, cy: 82 },   // Lingual / Palatal
};

// Rough footprint (rx, ry) for shapes drawn over each surface.
export const SURFACE_SIZE = {
  O: { rx: 12, ry: 7 },
  M: { rx: 5,  ry: 15 },
  D: { rx: 5,  ry: 15 },
  B: { rx: 12, ry: 5 },
  L: { rx: 12, ry: 5 },
};

// Root anatomy varies with tooth type — used by RCT & PeriapicalLesion.
export function rootCanals(type) {
  if (type === "molar")    return [
    { x: 17, tip: [10, 122] },
    { x: 43, tip: [50, 122] },
    { x: 30, tip: [30, 128] },
  ];
  if (type === "premolar") return [
    { x: 21, tip: [20, 126] },
    { x: 39, tip: [40, 126] },
  ];
  return [{ x: 30, tip: [30, 128] }];
}

// Convenience for making pseudo-unique gradient IDs.
export function uid(prefix, toothId) {
  return `${prefix}-${toothId ?? Math.random().toString(36).slice(2, 8)}`;
}
